import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69dab6aaa749570014e96d4d_1782636475848_623faa29/shipmanmacleod/src/app/fr/faq/page.tsx");
